export default {"src":"/_next/static/media/app-store_badge_sv.393b1cff.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};